import { RootState } from "domain/store";

export const selectVisualSupports = (state: RootState) => {
  return state.visualSupports.supports;
};

export const selectVisualSupport = (state: RootState) => {
  return state.visualSupports.support;
};

export const selectVisualSupportsTotalCount = (state: RootState) => {
  return state.visualSupports.totalCount;
};

export const selectRandomVisualSupport = (state: RootState) => {
  return state.visualSupports.randomVisualSupport;
};
